import Modal from 'developer_components/newModal';
import {createElement, error, hasWebpSupport} from 'methods/utils';
import Swiper from 'swiper';
import metrikaCollector, {collectYandexReachGoal} from 'components/metrika';
import { Navigation, Pagination } from 'swiper/modules';

const webpSupport = hasWebpSupport();

/**
 * Модалка на странице объекта
 */
function ApartmentPhotogallery() {
    let $apartmentSwiperContainer = document.querySelectorAll('.js-apartmentSwiperContainer');
    if ($apartmentSwiperContainer.length === 0) {
        return;
    }

    $apartmentSwiperContainer.forEach($item => {
        let loop        = true;
        let $slides     = $item.querySelectorAll('.js-slideItem');
        let $pagination = $item.querySelector('.js-pagination');

        if ($slides.length <= 1) {
            loop = false;

            if ($pagination) {
                $pagination.classList.add('is-hidden');
            }
        }

        let swiper = new Swiper($item, {
            pagination: {
                el: $item.querySelector('.pagination'),
                currentClass: 'current',
                hiddenClass: 'hidden',
                lockClass: 'lock',
                totalClass: 'total',
                clickableClass: 'clickable',
                dynamicBullets: true,
                dynamicMainBullets: 3,
                clickable: true,
            },
            navigation: {
                nextEl: $item.querySelector('.js-arrowNext'),
                prevEl: $item.querySelector('.js-arrowPrev'),
            },
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideNextClass: 'next',
            slidePrevClass: 'prev',
            slideDuplicateActiveClass: 'duplicate-active',
            slideDuplicateClass: 'duplicate',
            slideDuplicateNextClass: 'duplicate-next',
            slideDuplicatePrevClass: 'duplicate-prev',
            slideVisibleClass: 'visible',
            loop,
            on: {
                click: () => {
                    if (swiper.clickedSlide) {
                        this._openModal($item, swiper);
                    }
                }
            }
        });
    })
}

/**
 * Открываем модалку
 */
ApartmentPhotogallery.prototype._openModal = function($apartment, swiper) {
    let index = swiper.clickedSlide.dataset.pos;
    if (!$apartment || !$apartment.dataset.json_photo) {
        return;
    }

    let images;
    try {
        images = JSON.parse($apartment.dataset.json_photo);
    } catch(e) {
        error(e);
        return;
    }

    if (!images || images.length === 0) {
        return;
    }

    this._images = images.map(item => {
        let src = item.big_photo;

        if (window.screen.width <= 720 && webpSupport && item.photo_720_webp) {
            src = item.photo_720_webp;
        } else if (window.screen.width <= 720 && item.photo_720) {
            src = item.photo_720;
        } else if (item.photo_1080_webp && webpSupport) {
            src = item.photo_1080_webp;
        } else if (item.photo_1080) {
            src = item.photo_1080;
        }

        return `<div class="item swiper-slide" data-index="${item.pos}">
                    <img class="swiper-lazy swiper-lazy-loaded" src="${src}" loading="lazy">
                </div>`;
    });

    // удаляем пред модалки
    document.querySelectorAll('#apartment-photogallery-modal').forEach($item => $item.remove());

    this._$modal = createElement(`
    <div id="apartment-photogallery-modal" class="Modal-native">
        <div class="wrapper Modal-native__wrapper">
            <div class="header">
                <div class="left-block">
                    <button class="back js-modalClose">Назад</button>
                </div>
                <div class="right-block Page-menu-right js-headerRightBlock"></div>
            </div>
            <div class="content">
                <div class="arrow left js-leftArrow">
                    <div class="icon">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0607 21.0607C12.6464 20.4749 12.6464 19.5251 12.0607 18.9393L4.12132 11L12.0607 3.06066C12.6464 2.47487 12.6464 1.52513 12.0607 0.939339C11.4749 0.353553 10.5251 0.353553 9.93934 0.939339L0.939338 9.93934C0.353551 10.5251 0.353552 11.4749 0.939338 12.0607L9.93934 21.0607C10.5251 21.6464 11.4749 21.6464 12.0607 21.0607Z" fill="currentColor"/>
                        </svg>
                    </div>
                </div>
                <div class="main-photogallery js-mainGallery"></div>
                <div class="arrow right js-rightArrow">
                    <div class="icon">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.93934 21.0607C0.353553 20.4749 0.353554 19.5251 0.93934 18.9393L8.87868 11L0.939342 3.06066C0.353556 2.47487 0.353556 1.52513 0.939343 0.939339C1.52513 0.353553 2.47488 0.353553 3.06066 0.939339L12.0607 9.93934C12.6464 10.5251 12.6464 11.4749 12.0607 12.0607L3.06066 21.0607C2.47487 21.6464 1.52513 21.6464 0.93934 21.0607Z" fill="currentColor"/>
                        </svg>
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="counter js-counter">2 / ${this._images.length}</div>
                <div class="swiper js-navGallery">
                    <div class="nav-photogallery swiper-wrapper">
                        ${this._images.join('')}
                    </div>
                </div>
            </div>
        </div>
    </div>
    `);

    this._modal = new Modal(this._$modal);

    // добавляем в модалку кнопку избранного
    this._$modal.querySelector('.js-headerRightBlock').append(document.querySelector('.js-objectFavoriteHotel').cloneNode(true));

    // инициализация фоток
    this._initPhotogallery();

    this._modal.open();

    if (this._allCount > 5) {
        this._swiper.slideToLoop(index, 100);
    } else {
        this._swiper.slideTo(index, 100);
    }

    this._loadPhotogallerySlide(index);
}

/**
 * $el делает opacity с 1 до 0
 * В конце вызывает finishCallback
 */
ApartmentPhotogallery.prototype._opacityOut = function($el, finishCallback) {
    let myopacity = 1;
    finishCallback = typeof finishCallback === 'function' ? finishCallback : (() => {});

    function MyFadeFunction() {
        if (myopacity > 0) {
            myopacity -= 0.05;

            setTimeout(() => {
                MyFadeFunction()
            }, 10);
        } else {
            $el.remove();

            finishCallback();
        }

        $el.style.opacity = myopacity;
    }

    MyFadeFunction();
}

/**
 * Выбор фотки
 */
ApartmentPhotogallery.prototype._loadPhotogallerySlide = function(index = 0) {
    index = +index;

    this._prevIndex = index;
    let $clone = this._$items[index].cloneNode();

    // фоток в контейнере
    let $images = [...this._$mainGallery.querySelectorAll('div')];

    // новые фотки добавляем
    let $div = document.createElement('div');
        $div.appendChild($clone);

    let $img = $div.querySelector('img[data-src]');
    if ($img) {
        $img.src = $img.dataset.src;
    }

    this._$mainGallery.insertAdjacentElement('afterbegin', $div);

    // пред фотки удаляем
    $images.forEach($image => {
        if ($image.classList.contains('removing')) {
            return false;
        }

        $image.classList.add('removing');

        this._opacityOut($image);
    });

    // обновляем счетчик
    this._$counter.textContent = `${+index + 1} / ${this._allCount}`;
}

/**
 * Инициализация фоток
 */
ApartmentPhotogallery.prototype._initPhotogallery = function() {
    this._$mainGallery  = this._$modal.querySelector('.js-mainGallery');
    this._$navGallery   = this._$modal.querySelector('.js-navGallery');
    this._$counter      = this._$modal.querySelector('.js-counter');
    this._$leftArrow    = this._$modal.querySelector('.js-leftArrow');
    this._$rightArrow   = this._$modal.querySelector('.js-rightArrow');
    this._$items        = [...this._$navGallery.querySelectorAll('.item img')];
    this._allCount      = this._$items.length;

    Swiper.use([Navigation, Pagination]);

    this._swiper = new Swiper(this._$navGallery, {
        slidesPerView: 'auto',
        loop: false,
        centeredSlides: true,
        resizeObserver: true,
        updateOnWindowResize: true,
        // Disable preloading of all images
        preloadImages: false,
        watchSlidesProgress: true,
    });

    // срабатывает когда кликаешь по слайдеру
    this._swiper.on('click', (swiper, event) => {
        let index = +event.target.dataset.index;

        if (this._allCount > 5) {
            this._swiper.slideToLoop(index, 100);
        } else {
            this._swiper.slideTo(index, 100);
        }

        this._loadPhotogallerySlide(index);
    });

    // левая стрелка
    this._$leftArrow.addEventListener('click', () => {
        this._swiper.slidePrev(100);
        this._loadPhotogallerySlide(this._swiper.realIndex);
    });

    // правая стрелка
    this._$rightArrow.addEventListener('click', () => {
        this._swiper.slideNext(100);
        this._loadPhotogallerySlide(this._swiper.realIndex);
    });

    window.addEventListener('keydown', (e) => {
        switch(e.keyCode) {
            case 27: // esc
                this._$modal.dispatchEvent(new Event('close'));
                break;
            case 37: // влево
                this._$leftArrow.dispatchEvent(new Event('click'));
                break;
            case 39: // вправо
                this._$rightArrow.dispatchEvent(new Event('click'));
                break;
        }
    })

    // открытие модалки
    if (typeof yaCounter46243086 !== "undefined") {
        yaCounter46243086.reachGoal('apartment_gallery_open');
        collectYandexReachGoal(metrikaCollector, 'apartment_gallery_open');
    }
}

export default ApartmentPhotogallery;
